import QRCode from "qrcode";
import * as Sentry from "@sentry/browser";
import { getRandomTheme } from "../utils/themeUtils";

export const currentPollStore = (voteOptionImages = []) => ({
    randomizedTheme: {},
    showShareScreen: false,
    hasQrCode: false,
    currentVoteOptionImageIndex: 0,
    voteOptionImages,

    init() {
        this.randomizedTheme = getRandomTheme();
    },

    async copyToClipboard(url) {
        if ('clipboard' in navigator) {
            try {
                await navigator.clipboard.writeText(url);
            } catch (e) {
                Sentry.captureException(e);
            }
        }
    },

    async openShareMenu(title, url) {
        if ('share' in navigator) {
            try {
                await navigator.share({
                    title,
                    text: title,
                    url,
                });
            } catch (e) {
                // User aborted share. Do nothing.
            }
        }
    },

    async generateQRCode(url) {
        const ref = this.$refs.qr;

        if (!ref) {
            return;
        }

        try {
            await QRCode.toCanvas(ref, url);
            this.hasQrCode = true;
        } catch (e) {
            Sentry.captureException(e);
        }
    },

    prevImage() {
        if (this.currentVoteOptionImageIndex < this.voteOptionImages.length - 1) {
            this.currentVoteOptionImageIndex++;
        } else {
            this.currentVoteOptionImageIndex = 0;
        }
    },

    nextImage() {
        if (this.currentVoteOptionImageIndex > 0) {
            this.currentVoteOptionImageIndex--;
        } else {
            this.currentVoteOptionImageIndex = this.voteOptionImages.length - 1;
        }
    }
});
